// The signed-in admin on the API (LH-B1). Not persisted: the session lives in the httpOnly cookie, this store only
// remembers what the API last said about it. With the API off nobody signs in (the dev user picker is used instead).
import { create } from 'zustand'
import { ApiError, auth, setCsrf, type SessionView } from '@/lib/hubApi'

type Status = 'checking' | 'signed-out' | 'in'

interface SessionState {
  status: Status
  view: SessionView | null
  /** recovery codes to show once, right after 2-step was set up */
  recoveryCodes: string[] | null
  check: () => Promise<void>
  accept: (v: SessionView) => void
  signOut: () => Promise<void>
  dismissCodes: () => void
}

export const useSessionStore = create<SessionState>()((set) => ({
  status: 'checking',
  view: null,
  recoveryCodes: null,
  check: async () => {
    try {
      const v = await auth.session()
      setCsrf(v.csrf_token)
      set({ status: 'in', view: v })
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) set({ status: 'signed-out', view: null })
      else set({ status: 'signed-out', view: null })
    }
  },
  accept: (v) => {
    setCsrf(v.csrf_token)
    set((s) => ({ status: 'in', view: v, recoveryCodes: v.recovery_codes ?? s.recoveryCodes }))
  },
  signOut: async () => {
    await auth.signOut().catch(() => {})
    set({ status: 'signed-out', view: null, recoveryCodes: null })
  },
  dismissCodes: () => set({ recoveryCodes: null }),
}))
